


import React, { useEffect, useState } from 'react'
import { Pencil } from 'lucide-react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import { useParams } from 'react-router-dom';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { apiRoutes } from '../../../../routes/api/apiRoutes';

const TaskEdit = () => {

     const { id } = useParams();
  const [search, setSearch] = useState('');
  const [selectedTask, setSelectedTask] = useState(null);
  const [editData, setEditData] = useState({ name: '', description: '', status: '' });

  const [response, loading, error, callAPI] = useApiCallHooks();
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (id) {
      callAPI('get', `mentor/view-task/${id}`);
    }
  }, [id]);

  useEffect(() => {
    if (response?.data) {
      setTasks(response.data);
    }
  }, [response]);

  const openEditModal = (task) => {
    setSelectedTask(task);
    setEditData({ name: task.name, description: task.description, status: task.status });
    new window.bootstrap.Modal(document.getElementById('editModal')).show();
  };

  const handleChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleUpdate = () => {
    const updated = tasks.map((task) =>
      task.id === selectedTask.id ? { ...task, ...editData } : task
    );
    setTasks(updated);
    setSelectedTask(null);
    window.bootstrap.Modal.getInstance(document.getElementById('editModal')).hide();
  };

  const filteredTasks = tasks.filter(
    (task) =>
      task.name.toLowerCase().includes(search.toLowerCase()) ||
      task.description.toLowerCase().includes(search.toLowerCase())
  );
  return (
      <AdminAppBody
      loading={loading}
      content={
        <div className="p-4">
          <div className="card border-0 shadow">
            <div className="card-body">
              <h4 className="fw-bold mb-3">Task Details</h4>

              <div className="d-flex justify-content-end mb-3">
                <input
                  type="text"
                  className="form-control w-25 me-2"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <button className="custom-btn-blue">Search</button>
              </div>

              <table className="table text-center align-middle">
                <thead style={{ backgroundColor: '#dceeff' }}>
                  <tr>
                    <th>Sr No</th>
                    <th>Task Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTasks.length > 0 ? (
                    filteredTasks.map((task, index) => (
                      <tr key={task.id}>
                        <td>{index + 1}</td>
                        <td>{task.name}</td>
                        <td>{task.description}</td>
                        <td>
                          <span
                            className="badge"
                            style={{
                              backgroundColor: '#e6ffed',
                              color: '#28a745',
                              padding: '6px 12px',
                              borderRadius: '20px',
                              fontWeight: 500,
                            }}
                          >
                            {task.status}
                          </span>
                        </td>
                        <td>
                          <button
                            className="custom-btn-outline d-flex align-items-center justify-content-center gap-1 mx-auto"
                            onClick={() => openEditModal(task)}
                          >
                            <Pencil size={16} />
                            Update
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-muted">
                        No tasks found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Edit Task Modal */}
          <div
            className="modal fade"
            id="editModal"
            tabIndex="-1"
            aria-labelledby="editModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="editModalLabel">
                    Edit Task
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Task Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={editData.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      name="description"
                      className="form-control"
                      value={editData.description}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      name="status"
                      className="form-select"
                      value={editData.status}
                      onChange={handleChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="custom-btn-blue"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="button" className="custom-btn-blue" onClick={handleUpdate}>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Custom Styles */}
          <style>{`
            .custom-btn-blue {
              background-color: #004AAD;
              color: white;
              border: 1.5px solid #004AAD;
              padding: 6px 14px;
              font-weight: 500;
              border-radius: 6px;
              transition: 0.3s ease;
            }
            .custom-btn-blue:hover {
              background-color: white;
              color: #004AAD;
              border-color: #004AAD;
            }
            .custom-btn-outline {
              background-color: white;
              color: #004AAD;
              border: 1.5px solid #004AAD;
              padding: 6px 14px;
              font-weight: 500;
              border-radius: 6px;
              transition: 0.3s ease;
            }
            .custom-btn-outline:hover {
              background-color: #004AAD;
              color: white;
            }
          `}</style>
        </div>
      }
    />
  )
}

export default TaskEdit
